import { AccountGroup } from "@common/types/domains/accounting/account";
import { NestedEditorRow } from "./nestedRowTypes";

// Ids are `row.id` (the merged group row key), never a constituent id, so the
// picker lists each merged group once. Templates stay 1:1 (`row.id === group.id`).
export const nestedRowsToPickerGroups = (
    nestedRows: NestedEditorRow[],
): AccountGroup[] => {
    const pickerGroups: AccountGroup[] = [];
    const visit = (
        row: NestedEditorRow,
        parentGroupRowId: string | null,
    ): void => {
        if (row.kind === "group" && row.group) {
            pickerGroups.push({
                id: row.id,
                entityId: row.group.entityId,
                name: row.name,
                type: row.accountType ?? row.group.type,
                parentGroupId: parentGroupRowId,
                sortOrder: row.group.sortOrder,
            });
            row.children?.forEach((child) => visit(child, row.id));
            return;
        }
        const nextParent = row.kind === "type" ? null : parentGroupRowId;
        row.children?.forEach((child) => visit(child, nextParent));
    };
    nestedRows.forEach((row) => visit(row, null));
    return pickerGroups;
};
